import { cn } from "@/lib/utils";

export const LOGO_URL =
  "https://customer-assets-rejwkqb3.emergentagent.net/job_bigtek-products/artifacts/zykuq3hk_FullLogo%20%283%29.jpg";

// BIGTEK / Bigibila echidna badge. The supplied art is white-on-black, so we
// use `mix-blend-screen` to drop the black background and let the white mark
// sit cleanly on the dark UI.
export function Logomark({ className, ...props }) {
  return (
    <img
      src={LOGO_URL}
      alt="BIGTEK — Bigibila"
      className={cn("h-9 w-9 shrink-0 object-contain mix-blend-screen", className)}
      {...props}
    />
  );
}
